var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 85,
    viewBox: "0 0 64 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 6.875C31.875 6.3125 33.125 6 34.375 6H38C39.6875 6 40.8125 7.6875 40.25 9.3125C39.125 12.3125 36.875 14.8125 33.9375 16.3125L16.875 24.8125C16.625 24.9375 16.3125 25 16 25H7.375C6.8125 25 6.25 24.75 5.875 24.3125L1.3125 19C0.875 18.5 1.0625 17.75 1.625 17.4375L3.625 16.4375C4.1875 16.1875 4.8125 16.1875 5.3125 16.4375L8.9375 18L15.125 14.875L5.9375 9C5.3125 8.5625 5.375 7.5625 6.0625 7.25L8.9375 5.8125C9.875 5.3125 11.0625 5.25 12.125 5.625L24.3125 10.1875L30.75 6.875ZM0.5 33C0.5 31.9375 1.375 31 2.5 31H38.5C39.5625 31 40.5 31.9375 40.5 33C40.5 34.125 39.5625 35 38.5 35H2.5C1.375 35 0.5 34.125 0.5 33Z",
    fill: "#0059B8",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.3fc090dea3df29c53e49e4b18fecb9fa.svg";
export { ForwardRef as ReactComponent };